import { render, staticRenderFns } from "./AlternativesKanbanPage.vue?vue&type=template&id=527d9cf8&scoped=true"
import script from "./AlternativesKanbanPage.vue?vue&type=script&lang=ts"
export * from "./AlternativesKanbanPage.vue?vue&type=script&lang=ts"
import style0 from "./AlternativesKanbanPage.vue?vue&type=style&index=0&id=527d9cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d9cf8",
  null
  
)

export default component.exports